<template>
  <div class="yhglHome">
    <div class="thrkBody">
      <div class="bodyHeader">
        <el-form
          ref="search"
          label-width="90px"
          :model="formInline"
          label-position="left"
          style="
            width: 90%;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          "
        >
          <el-form-item label="登录名称:">
            <el-input
              v-model="formInline.loginName"
              placeholder="请输入登录名称"
            />
          </el-form-item>
          <el-form-item label="姓名:">
            <el-input
              v-model="formInline.userName"
              placeholder="请输入姓名"
            />
          </el-form-item>
          <el-form-item label="手机号码:">
            <el-input
              v-model="formInline.phonenumber"
              placeholder="请输入手机号码"
            />
          </el-form-item>
          <el-form-item label="用户状态:">
            <el-select v-model="formInline.status" style="width: 100%">
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:">
            <el-date-picker
              v-model="formInline.beginTime"
              type="date"
              placeholder="开始时间"
              value-format="yyyy-MM-dd"
            />
            -
            <el-date-picker
              v-model="formInline.endTime"
              type="date"
              placeholder="结束时间"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <div>
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              size="small"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh-left"
              style="width: 90px; height: 39px"
              round
              size="small"
              @click="resetDataSource"
            >重置</el-button>
          </div>
        </el-form>
      </div>
      <div class="thrkRight">
        <div class="bodyTable">
          <div class="thrkLeft1">
            <el-tree
              ref="TestTree"
              :data="deptTree"
              :props="defaultProps"
              show-checkbox
              check-strictly
              node-key="value"
              @check-change="handleCheckChange"
            >
              <template slot-scope="{ node }">
                <span class="curNodeStyle" :title="node.label">{{
                  node.label
                }}</span>
              </template>
            </el-tree>
          </div>
          <div class="thrkLeft2">
            <div class="addmessheader">
              <el-button
                type="primary"
                class="addmess"
                size="mini"
                icon="el-icon-upload2"
              >
                导出</el-button>
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-download"
              >导入</el-button>
              <el-button
                v-preventReClick
                type="primary"
                size="mini"
                icon="el-icon-circle-plus-outline"
                @click="addItem"
              >添加</el-button>
            </div>
            <el-table
              border
              :data="tableData"
              :header-cell-style="{
                'text-align': 'center',
                background: '#f4f4f4',
              }"
              :cell-style="{ 'text-align': 'center' }"
              style="width: 100%"
            >
              <el-table-column
                prop="loginName"
                label="登录名称"
                show-overflow-tooltip
              />
              <el-table-column prop="userName" label="用户名称" />
              <el-table-column
                prop="deptName"
                label="部门"
                show-overflow-tooltip
              />
              <el-table-column
                prop="phonenumber"
                label="手机"
                show-overflow-tooltip
              />
              <el-table-column prop="statusStr" label="用户状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.statusStr }}</span>
                  <!-- <el-switch
                    v-model="scope.row.status"
                    active-value="0"
                    inactive-value="1"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch> -->
                </template>
              </el-table-column>
              <el-table-column prop="cjsj" label="创建时间" width="200" />
              <el-table-column label="操作" width="300px">
                <template slot-scope="scope">
                  <el-button
                    v-preventReClick
                    size="mini"
                    style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                    icon="el-icon-circle-plus-outline"
                    @click="editItem(scope.row)"
                  >编辑</el-button>
                  <el-button
                    v-preventReClick
                    size="mini"
                    style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                    icon="el-icon-circle-plus-outline"
                    @click="deleteItem(scope.row)"
                  >删除</el-button>
                  <el-button
                    v-preventReClick
                    size="mini"
                    style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                    icon="el-icon-circle-plus-outline"
                    @click="resetPassword(scope.row)"
                  >重置密码</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              background
              layout="prev,pager,next,jumper,total,sizes"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pagesize"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      :close-on-click-modal="false"
      :closeOnPressEscape="false"
      :visible.sync="passwordDialogVisible"
      width="500px"
      center
    >
      <div slot="title" class="header-title">
        <i class="el-icon-lock"></i>
        <span>重置密码</span>
      </div>
      <el-form label-position="left" style="width: 95%; margin: 30px auto">
        <el-form-item label="登录名称" label-width="80px">
          <el-input v-model="resetPasswordForm.username"></el-input>
        </el-form-item>
        <el-form-item label="输出密码" label-width="80px">
          <el-input v-model="resetPasswordForm.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          v-preventReClick
          @click="sureDelete"
          style="background: #4170ff; border-color: #4170ff"
          >确 认</el-button
        >
      </span>
    </el-dialog> -->
    <yhgl-dialog ref="yhglDialog" />
  </div>
</template>
<script>
import yhglDialog from './yhglDialog.vue'
import {
  getDeptTree,
  getUserAll,
  deleteUser,
  resetPassword
} from '@/assets/js/yhgl.js'
export default {
  name: 'User',
  components: { yhglDialog },
  data() {
    return {
      defaultProps: {
        label: 'label',
        key: 'value'
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 列表总数
      deptTree: [], // 部门树
      tableData: [], // 表格数据
      formInline: {
        // 搜索表单
        loginName: '',
        userName: '',
        phonenumber: '',
        status: '',
        beginTime: '',
        endTime: ''
      },
      statusList: [
        // 状态列表
        {
          label: '正常',
          value: '0'
        },
        {
          label: '停用',
          value: '1'
        }
      ]
    }
  },

  watch: {},
  created() {},
  mounted() {
    // 获取区划树
    getDeptTree().then((e) => {
      this.deptTree = e.data.data
    })
    this.loadDatasource()
  },
  beforeDestroy() {},
  methods: {
    // 重置
    resetDataSource() {
      this.formInline = {
        loginName: '',
        userName: '',
        phonenumber: '',
        status: '',
        beginTime: '',
        endTime: ''
      }
      this.$refs.TestTree.setCheckedKeys([])
      this.loadDatasource()
    },
    // el-tree 单选
    handleCheckChange(data, checked, node) {
      if (checked) {
        this.$refs.TestTree.setCheckedKeys([])
        this.$refs.TestTree.setCheckedKeys([data.value])
        this.loadDatasource()
      }
    },
    // 查询列表数据
    loadDatasource() {
      getUserAll({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          loginName: this.formInline.loginName,
          userName: this.formInline.userName,
          phonenumber: this.formInline.phonenumber,
          status: this.formInline.status,
          deptId: this.$refs.TestTree.getCheckedKeys()[0],
          beginTime: this.formInline.beginTime,
          endTime: this.formInline.endTime
        }
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 重置密码
    resetPassword(row) {
      // this.passwordDialogVisible = true;
      this.$confirm("此操作将把此用户密码重置为\"yzd@警号后四位\"，不足四位则末位补0,如(yzd@0100),是否重置?", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          resetPassword(row.userId).then((e) => {
            if (e.data.code == '000000') {
              this.$message({
                type: 'success',
                message: '密码重置成功'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置'
          })
        })
    },
    // 添加弹窗显示
    addItem() {
      this.$refs.yhglDialog.dialogVisible = true
      this.$refs.yhglDialog.todoType = 'add'
    },
    // 重置密码
    /* sureDelete() {
      this.$confirm("是否重置密码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //   deletescrkMes(row.id).then((e) => {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.passwordDialogVisible = false;
          // this.search();
          //   });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }, */
    // 删除
    deleteItem(row) {
      this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteUser(row.userId).then((e) => {
            if (e.data.code == '000000') {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.loadDatasource()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 编辑
    editItem(row) {
      this.$refs.yhglDialog.dialogVisible = true
      this.$refs.yhglDialog.todoType = 'edit'
      this.$refs.yhglDialog.jbxxForm = row
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadDatasource()
    }
  }
}
</script>
<style scoped lang='less'>
.yhglHome {
  .thrkBody {
    margin: 0 auto;
    .bodyHeader {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      margin-bottom: 11px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      padding: 30px 0 0 0;
      border-radius: 5px;
      .el-form-item {
        margin-right: 30px;
        width: 22%;
        &:nth-child(4) {
          margin-right: 0px;
        }
        &:nth-child(5) {
          width: 50%;
          .el-date-editor {
            width: 40%;
          }
        }
        .el-form-item__content {
          display: flex;
        }
      }

      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-color: #4170ff;
        width: 90px;
        height: 39px;
      }
    }
    .thrkRight {
      width: 95%;
      background-color: #fff;
      height: 70vh;
      height: calc(70vh - 2px);
      margin: 0 auto;
      padding-top: 40px;
      padding-bottom: 57px;
      .bodyTable {
        width: 90%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .thrkLeft1 {
          width: 350px;
          height: 100%;
          overflow-y: auto;
          padding-right: 20px;
          /deep/.el-tree-node__label {
            width: 90%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: inline-block;
          }
        }
        .thrkLeft2 {
          width: calc(100% - 350px);
          height: 100%;
          overflow-y: auto;
          .addmessheader {
            background: #f4f4f4;
            .addmess {
              margin: 12px 0 12px 8px;
            }
          }
          .el-button--primary {
            color: #fff;
            background: #4170ff;
            border-radius: 3px;
            border-color: #4170ff;
          }
        }
      }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  .header-title {
    text-align: left;
  }
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.el-table::before {
  height: 0;
}
.curNodeStyle {
  font-size: 14px;
  width: 20px;
  display: inline-block;
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  color: #606266;
}
</style>
